import type { PermissionKey } from 'constants-permissions';
import { compareUUIDs } from 'uuid-encoding';
import { isActive } from './toActor';

export type ChannelRole = {
  expires?: Date;
  groupRole: {
    permissions: PermissionKey[];
    channel?: { _id: string };
  };
};

export const hasPermissionOnExactChannel = (
  roles: ChannelRole[] | undefined,
  permission: PermissionKey,
  channelId: string | null | undefined
): boolean => {
  const now = new Date();

  return (roles ?? []).some(
    role =>
      isActive(role, now) &&
      compareUUIDs(role.groupRole.channel?._id, channelId) &&
      role.groupRole.permissions.includes(permission)
  );
};
